/** Settings-route provider slug when backend omits `provider` in the error payload. */
export const FALLBACK_PLAYGROUND_PROVIDER_SLUG = "openai";
